module.exports = __webpack_public_path__ + "img/empty.f479ca62.png";